import { buildVarMap, extractConditionBlocks, extractFieldKeyFromSelector } from '../utils';

const JQUERY_DISABLE_PATTERN = /\$\(\s*(\w+)\s*\)\.prop\(\s*["']disabled["']\s*,\s*(true|false)\s*\)/g;
const VANILLA_DISABLE_PATTERN = /document\.querySelector\(\s*(?:"([^"]+)"|'([^']+)')\s*\)\.disabled\s*=\s*(true|false)/g;
export function detectDisablePatterns(script, ownerFieldKey) {
  if (!script) return [];
  const effects = [];
  const varMap = buildVarMap(script);
  const conditionBlocks = extractConditionBlocks(script);

  conditionBlocks.forEach(({ condition, body }) => {
    const actions = [];

    let match;
    JQUERY_DISABLE_PATTERN.lastIndex = 0;
    while ((match = JQUERY_DISABLE_PATTERN.exec(body)) !== null) {
      const target = varMap[match[1]];
      const isDisabled = match[2] === 'true';
      if (target) {
        actions.push({ target, action: isDisabled ? 'disable' : 'enable' });
      }
    }

    VANILLA_DISABLE_PATTERN.lastIndex = 0;
    while ((match = VANILLA_DISABLE_PATTERN.exec(body)) !== null) {
      const selector = match[1] ?? match[2];
      const isDisabled = match[3] === 'true';
      const target = extractFieldKeyFromSelector(selector);
      if (target) {
        actions.push({ target, action: isDisabled ? 'disable' : 'enable' });
      }
    }

    if (actions.length > 0) {
      effects.push({ when: condition, actions });
    }
  });

  return effects;
}
